/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as angular from 'angular';

angular
	.module('ticketspaceApp')
	//deprecating this factory, it's much too limited
	.factory('subscriber', function () {
		//virtual class
		let virtualObserver = (function () {
			function observe() {
				for (let i = 0; i < this.observers.length; i++) {
					this.observers[i].apply(undefined, arguments);
				}
			}

			function subscribe(fn) {
				this.observers.push(fn);
				//unsubscribe function
				return function () {
					this.unsubscribe(fn);
				};
			}

			function unsubscribe(fn) {
				for (let i = 0; i < this.observers.length; i++) {
					if (this.observers[i] === fn) {
						this.observers.splice(i, 1);
					}
				}
			}

			return {
				subscribe,
				unsubscribe,
				observe,
			};
		})();

		//#### create()
		// runs through the object.create flow so that a new object is created
		function create(ctx) {
			let newObj = Object.create(virtualObserver);
			newObj.observers = [];
			return newObj;
		}

		return {
			create,
		};
	})

	//todo - implement an off
	// - on should support multiple types
	.factory('Subscriber2', function () {
		function Subscriber() {
			this._observers = { '': [] };
		}
		Subscriber.prototype = {
			//valid types:
			// - "aString",
			// - "space seperated list"
			// - nothing...
			on: function on(type, cb) {
				if (typeof type === 'function') {
					cb = type;
				}
				if (!type || typeof type === 'function') {
					this._observers[''].push(cb);
					return [];
				}
				type = type.trim();
				let typeList = type.split(' ');
				typeList.forEach(function (t) {
					if (!this._observers[t]) {
						this._observers[t] = [];
					}
					this._observers[t].push(cb);
				}, this);
				return typeList;
			},
			//return a summary of return values, any trues with cause a final true, all falsy will be false
			// consider a special emit that returns a full array with all the individual results
			emit: function emit(type) {
				let args = Array.prototype.slice.call(arguments, 1);
				let resultSummary;

				if (this._observers[type]) {
					this._observers[type].forEach(function (fn) {
						resultSummary = fn.apply(undefined, args) || resultSummary;
					});
				}
				//hit the ones that want everything
				this._observers[''].forEach(function (fn) {
					resultSummary = fn.apply(undefined, args) || resultSummary;
				});
				return resultSummary;
			},
			extend: function extend(obj) {
				let self = this;
				let external = ['on', 'emit'];
				external.forEach(function (key) {
					obj[key] = self[key].bind(self);
				});
			},
		};
		return Subscriber;
	});
